import React, { useMemo } from 'react';

import { useUsers, useRoles } from '@adsk/alloy-provider';
import Avatar from '@adsk/alloy-react-avatar';
import HighlightText from '@adsk/alloy-react-highlight-text';
import { PeopleIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { MentionData } from '../../consts';
import { useTranslation } from '../../i18n';

export const MentionRoleSuggestion = ({
  suggestion,
  searchValue,
}: {
  suggestion: MentionData;
  searchValue?: string;
}) => {
  const { t } = useTranslation();
  const users = useUsers();
  const roles = useRoles();
  const currentRole = useMemo(
    () => roles.data.find((role) => role.memberGroupId === suggestion.id),
    [roles.data, suggestion.id],
  );
  const userWithRoleCount = useMemo(
    () =>
      users.data?.filter((user) =>
        user.roleIds?.includes(currentRole?.id || ''),
      ).length,
    [currentRole?.id, users.data],
  );

  return (
    <>
      <Avatar
        style={{
          color: theme.colors.charcoal500,
          backgroundColor: theme.colors.charcoal100,
        }}
      >
        <PeopleIcon />
      </Avatar>
      <span style={{ marginLeft: 10 }}>
        <div
          style={{
            width: '100%',
            display: 'table',
            tableLayout: 'fixed',
          }}
        >
          <OverflowTooltip content={currentRole?.name || suggestion.name}>
            <HighlightText
              matched={searchValue}
              text={
                currentRole?.name ||
                suggestion.name ||
                t('FORMER_ROLE')?.toString()
              }
              style={{
                ...theme.typography.bodyMedium,
                color: theme.colors.charcoal900,
              }}
              highlightStyle={{
                ...theme.typography.bodyMediumBold,
                backgroundColor: 'transparent',
              }}
            />
          </OverflowTooltip>
          <div
            style={{
              ...theme.typography.bodySmall,
              color: theme.colors.charcoal700,
            }}
          >
            <OverflowTooltip
              content={t('USERS_COUNT', {
                count: userWithRoleCount,
              })}
            >
              {t('USERS_COUNT', { count: userWithRoleCount })}
            </OverflowTooltip>
          </div>
        </div>
      </span>
    </>
  );
};
